// extracted by mini-css-extract-plugin
module.exports = {"accountLogo":"styles_accountLogo__KO8bv","educatorImage":"styles_educatorImage__qQkED","defaultImage":"styles_defaultImage__PKBZc"};